import React from 'react';
import './Mango_Color_Btn.css';

const Mango_Color_Btn = ({ btn_name, onClick, extraClass = '' }) => {
    return (
        <button className={`Mango_Color_Btn ${extraClass}`} onClick={onClick}>
            <p className="btn_text">{btn_name}</p>
        </button>
    );
};

export default Mango_Color_Btn;
